import secureApi from "../services/secureApi";

// ================= LIST =================
export const getBulkOrders = async (page = 1, limit = 10) => {
  try {
    const response = await secureApi.get(
      `/admin/bulk-order/list?page=${page}&limit=${limit}`
    );

    return response.data;
  } catch (error) {
    console.error("GET BULK ORDERS ERROR:", error);

    return {
      data: [],
      pagination: {
        totalPages: 0,
        currentPage: 1,
        totalItems: 0,
      },
    };
  }
};

// ================= VIEW =================
export const getBulkOrderById = async (id) => {
  try {
    const response = await secureApi.get(`/admin/bulk-order/view/${id}`);

    console.log("VIEW BULK ORDER =>", response.data);

    return response.data;
  } catch (error) {
    console.error("VIEW BULK ORDER ERROR:", error);
    return null;
  }
};